import {ReactComponent as PlayIcon} from './play.svg'

function Play() {
  return <PlayIcon />
}

export default Play
